import app from '../app'; // eslint-disable-line

/**
 * Fetch cart
 * @returns {object} cart
 */
const fetchCart = () => fetch('/cart?view=data', {
  method: 'GET',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
}).then((response) => response.json());

/**
 * Add item to cart based on variant ID
 * @param {int} variantId
 * @param {int} quantity
 * @param {function} callback
 */
const addVariant = ({
  variantId,
  quantity,
  callback,
}) => new Promise((resolve) => {
  app.emit('cart:disable');

  const formData = {
    id: variantId,
    quantity,
    sections: 'cart-drawer',
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then(async ({ sections }) => {
      const { itemCount, items, cartTotal } = await fetchCart();
      const cartDrawerMarkup = sections['cart-drawer'];

      app.emit('cart:updated', {
        itemCount,
        items,
        cartDrawerMarkup,
        cartTotal,
      });

      if (callback) {
        callback();
      }

      resolve(app.emit('cart:enable'));
    });
});

/**
 * Change cart item
 * @param {string} key - can either be line item key or variant ID
 * @param {int} quantity
 * @param {function} callback
 */
const changeItem = ({
  key,
  quantity,
  callback,
}) => new Promise((resolve) => {
  app.emit('cart:disable');

  const formData = {
    id: key,
    quantity,
    sections: 'cart-drawer',
  };

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then(async (data) => {
      const { itemCount, items, cartTotal } = await fetchCart();
      const cartDrawerMarkup = data.sections['cart-drawer'];

      app.emit('cart:updated', {
        itemCount,
        items,
        cartDrawerMarkup,
        cartTotal
      });

      if (callback) {
        callback();
      }

      resolve(app.emit('cart:enable'));
    });
});

export { addVariant, changeItem, fetchCart };

